export const SHOPIFY_STOCK_CATEGORY_ID = 159;
